export default __webpack_public_path__ + "static/media/a.46859cd1.svg";